import React, { useState, useEffect, useRef, useCallback } from 'react'
import {
  Row,
  Col,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactTags from 'react-tag-autocomplete'

// AspIdItem
const AspIdItem = (props) => {

  let aspDictTagsRef = useRef()

  let [dictTags, setDictTags] = useState([])
  let [dictSuggestions, setDictSuggestions] = useState([])



  // componentDidMount
  useEffect(() => {

    if (!props.item) {
      return
    }

    if (props.item.dictionary_items && props.item.dictionary_items.length > 0) {
      setDictTags(props.item.dictionary_items)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.item]);




  // update 
  let _updateAspItem = () => {
    props.updateAspItem(props.item, dictTags)
  }

  // tracking keyword suggestions
  useEffect(() => {

    if (!props.shareableDictionarySuggestions) {
      return
    }
    
    setDictSuggestions(props.shareableDictionarySuggestions)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.shareableDictionarySuggestions]);


  // onAdditionKeywords
  let onAdditionKeywords = useCallback((newTag) => {

    let _exists = false
    let _tags = dictTags
    for (let i=0; i<_tags.length; i++) {
      if (_tags[i].id === newTag.id) {
        _exists = true
        break
      }
    }

    if (_exists === false) {
      setDictTags([..._tags, newTag])
    }

  }, [dictTags])

  // onDeleteKeywords
  let onDeleteKeywords = useCallback((tagIndex) => {
    setDictTags(dictTags.filter((_, i) => i !== tagIndex))
  }, [dictTags])


  return (
    <Row style={{
      marginLeft: 0,
      marginRight: 0,
      marginTop: 10,
      marginBottom: 10,
      backgroundColor: props.idx % 2 === 0 ? '#efefef' : '#ffffff',
    }}>

      <Col md="3" xs="12" style={{
        textAlign: 'left',
      }}>

        {props.item.asp_id}

      </Col>
      <Col md="3" xs="12" style={{
        textAlign: 'left',
      }}>
        {props.item.asp_name}
      </Col>
      <Col md="5" xs="12" style={{
        textAlign: 'left',
      }}>

        <ReactTags
          ref={aspDictTagsRef}
          tags={dictTags}
          suggestions={dictSuggestions}
          onDelete={onDeleteKeywords}
          onAddition={onAdditionKeywords}
        />

      </Col>

      <Col md="1" xs="12" style={{
        textAlign: 'left',
      }}>

        <FontAwesomeIcon
          onClick={_updateAspItem}
          icon="save"
          style={{
            cursor: 'pointer',
            marginRight: 10,
            marginLeft: 10,
        }}/>

      </Col>

    </Row>
  )
}

export default AspIdItem
